(() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  class HeaderSection extends HTMLElement {
    constructor() {
      super();
      this.open_menu_on_hover = this.dataset.hover == "hover";
      this.items = this.querySelector(".header__inline-menu")?.querySelectorAll(
        "details"
      );
      this.headerIconMenu = this.querySelectorAll(".header__icon--menu");
      this.mobileDockMenu = document.querySelector(".bottom_mobile_dock-menu");
      this.countrySelectors = this.querySelectorAll(
        ".country_selector-inspired-container"
      );
      this.menuMobileIcon = this.querySelector(
        ".header-mobile-menu .mobile-menu-drawer-icon"
      );
      this.searchs = document.querySelectorAll(".header__search");
      this.rootItems = this.querySelectorAll(
        ".list-menu .list-menu__item-root"
      );
      this.fullWidthBannerItems = document.querySelectorAll(
        ".list-full-width-banner__item"
      );

      this.mobileCountryButton = document.querySelector(
        ".country-region-selector-button"
      );
      this.mobileLanguageButton = document.querySelector(
        ".language-region-selector-button"
      );
      
      this.mobileSearchBar = document.querySelector('.mobile-search-bar .mobile-search-bar-input');
      
      if (this.mobileSearchBar) this.mobileSearchBar.addEventListener('click', function() {
        const searchModal = document.getElementById('modal-search');
        if (searchModal) searchModal.show(this.buttonOpener);
      });

      // window.addEventListener("scroll", this.onScrollHandler, false);

      document.addEventListener("shopify:section:load", function (event) {
        const isSelectorSection = event.target.querySelector('header-section');
        if (!isSelectorSection) return;
        const header = event.target.querySelector(
          ".header-section-items__container"
        );
        // if (header?.dataset?.hover == "true")
        //   this.onHoverItem(header.querySelectorAll(".header__inline-menu"));
        if (header?.dataset?.collapse == "true") this.setCollapseMenu(header);
      });

      this.mobileDockMenu?.addEventListener(
        "click",
        this.triggerOpenMenu.bind(this)
      );
      this.countrySelectors.forEach((btn) =>
        btn.addEventListener("click", this.openCountryMenu.bind(this))
      );
      this.menuMobileIcon?.addEventListener(
        "click",
        this.toggleMobileMenu.bind(this)
      );

      this.mobileCountryButton?.addEventListener("click", function (e) {
        const countryDrawer = document.getElementById(
          "menu-drawer__country-drawer"
        );
        if (countryDrawer) {
          countryDrawer.show(e);
        }
      });

      this.mobileLanguageButton?.addEventListener("click", function (e) {
        const languageDrawer = document.getElementById(
          "menu-drawer__language-drawer"
        );
        if (languageDrawer) {
          languageDrawer.show(e);
        }
      });

      // if (this.dataset.hover == "true") this.onHoverItem(this.items);
      this.init();

      window.addEventListener("resize", this.init());

      this.querySelectorAll('insp-dropdown').forEach(ele => ele.addEventListener('dropdownToggle', this.showMegaMenu.bind(this, ele)));
    }

    init() {

      for (let index = 0; index < this.rootItems.length; index++) {
        const element = this.rootItems[index];
        const itemWidth = element.clientWidth;
        element.style.setProperty("--header-item-width", `${itemWidth}px`);
      }

      
    }

    showMegaMenu(ele, e) {
      const clientWidth = Math.round(document.body.clientWidth);
      const show = e?.detail?.show || false;
      if (show) {
        const fullWidthBannerItems = ele.querySelectorAll('.list-full-width-banner__item');
        for (let index = 0; index < fullWidthBannerItems.length; index++) {
          const element = fullWidthBannerItems[index];
          const contentHeight =
            element.querySelector(".menu_full-width-banner__content")
              ?.clientHeight || 0;
          const paddingLR = clientWidth < 750 ? 16 : 100;
          element.style.setProperty(
            "--full-width-banner-item-min-height",
            `${contentHeight + paddingLR}px`
          );
        }
      }
    }

    onScrollHandler(e) {
      const currentScroll = window.scrollY;
      const clientWidth = Math.round(document.body.clientWidth);
      // const mobileSearchBar = document.querySelector(".mobile-search-bar");

      // if (mobileSearchBar && clientWidth < 750) {
      //   if (currentScroll > 100) {
      //     mobileSearchBar.classList.add("mobile-display-none");
      //   } else {
      //     mobileSearchBar.classList.remove("mobile-display-none");
      //   }
      // }

      const mobileSearchBarDropdow = document.getElementById('mobile-search-bar-dropdown');
      if (mobileSearchBarDropdow) {
        mobileSearchBarDropdow.closePopover();
      }
    }

    toggleMobileMenu(e) {
      const target =
        e.target.closest(".mobile-menu-drawer-icon") ||
        e.srcElement.closest(".mobile-menu-drawer-icon");
      const mobileMenuItems = document.querySelector(".header nav");

      if (!target || !mobileMenuItems) return;
      if (target.classList.contains("header-mobile-menu-open")) {
        target.classList.remove("header-mobile-menu-open");
        this.closest('.header-wrapper').classList.remove("show-mobile-menu-items");
      } else {
        target.classList.add("header-mobile-menu-open");
        this.closest('.header-wrapper').classList.add("show-mobile-menu-items");
      }
    }

    openCountryMenu(event) {
    }

    setPosistionMenu(header) {
      const headerHeading = header.querySelector(".header__heading");
      const headerMenu = header.querySelector(".header__inline-menu");
      headerHeading.appendChild(headerMenu);
    }

    setCollapseMenu(header) {
      const headerMenu = header.querySelector(".header__inline-menu");
      const headerDrawer = header.querySelector("header-drawer");
      const headerSocial = header.querySelector(".header_social");
      setTimeout(() => {
        if (header.querySelector(".header__inline-menu").clientHeight > 50) {
          headerMenu.style.display = "none";
          headerSocial.style.display = "none";
          headerDrawer.style.display = "flex";
          headerDrawer.style.gridArea = "auto";
          header.classList.remove("header--middle-left");
        }
      }, 500);
    }

    openMenu(event) {
      const sideMenu = document.getElementById("Details-menu-drawer-container");
      const header = document.getElementById("site-header");
      const headerWrapper = header.parentElement;
      if (!sideMenu.classList.contains("menu-opening")) {
        header.classList.remove("site-header-transparent");
        headerWrapper.classList.remove("header-wrapper-transparent");
      } else {
        header.classList.add("site-header-transparent");
        headerWrapper.classList.add("header-wrapper-transparent");
      }
    }

    triggerOpenMenu(e) {
      e.preventDefault();
      e.stopPropagation();
      document
        .getElementById("Details-menu-drawer-container")
        ?.querySelector("summary")
        ?.click();
    }

    openSearch() {
      const search = document.getElementById("template-index");
      const header = document.getElementById("site-header");
      const headerWrapper = header.parentElement;
      const main = document.getElementById("MainContent");
      const height = document.getElementById("site-header").offsetHeight;
      if (window.pageYOffset < height) {
        if (search.classList.contains("overflow-hidden")) {
          header.classList.remove("site-header-transparent");
          headerWrapper.classList.remove("header-wrapper-transparent");
          //main.classList.remove('has-site-header-transparent');
        } else {
          header.classList.add("site-header-transparent");
          headerWrapper.classList.add("header-wrapper-transparent");
          //main.classList.add('has-site-header-transparent');
        }
      }
    }
  }

  if (!customElements.get("header-section")) {
    customElements.define("header-section", HeaderSection);
  }

  if (!customElements.get("brand-message")) {
    customElements.define("brand-message", class BrandMessage extends SlideUpImages {
      constructor() {
        super();
        const self = this;
        this.logoImage = this.querySelector('.header__heading-logo');
        this.brandMessage = this.querySelector('.header__heading-brand-message');

        // const newDuration = this.duration * 2;

        // setTimeout(() => {
        //   if (this.images < 2) return;
        //   this.container.style.setProperty('--slide-up-images-duration', `${newDuration * this.images.length}s`);
        //   this.images.forEach((img, index) => {
        //     img.style.animationDelay = `${newDuration * index}s`;
        //   });
        // }, newDuration * 1000);
        
      }

      setHeightBrandMessage() {
        setTimeout(() => {
          this.logoImage = this.querySelector('.header__heading-logo');
          this.brandMessage = this.querySelector('.header__heading-brand-message');
          if (this.logoImage && this.brandMessage) {
            this.brandMessage.style.height = `${this.logoImage.clientHeight}px`;
            this.brandMessage.style.width = 'auto';
            this.brandMessage.style.margin = 'auto';
          }
        }, 0);
      }
    });
  }

  /******/
})();
